/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
   
  //  setTimeout(function() { 
  //     var announcebarHeight = document.querySelector('.announcement-bar-static').offsetHeight;
  //     var headerHeight = document.querySelector('.shopify-section-header').offsetHeight;
  //     var totalHeight = announcebarHeight + headerHeight;
  //     document.querySelector('.mobile-nav-drawer').style.top = totalHeight+'px';
  // },1000);

  

  var accordion_click = document.querySelector(".product__block.product__accordions .product__accordion button")
  if (accordion_click) {
    setTimeout(function() { 
      accordion_click.click();
    },1000);  
  }

  // mobile filter css

  var blog_title = document.querySelector('.blog__tags-title');
  if (blog_title) {
    document.querySelector('.blog__tags-title').addEventListener('click', (elm)=>{
      document.querySelector('.blog__tags').classList.toggle('active');
    });
  }

   // mobile menu js
  
    document.querySelectorAll('.mobile-nav-button').forEach((elm)=>{
      elm.addEventListener('click', (el)=>{
        document.querySelectorAll('.mobile-nav-submenu').forEach((e)=>{
          e.classList.remove('active')
        });
        document.querySelector('.mobile-nav-list').classList.add('child-open')
        el.currentTarget.nextElementSibling.classList.add('active');
      });
    })

    document.querySelectorAll('.prev-nav-header').forEach((elm)=>{
      elm.addEventListener('click', (el)=>{
        document.querySelectorAll('.mobile-nav-submenu').forEach((e)=>{
          e.classList.remove('active')
        });
        document.querySelector('.mobile-nav-list').classList.remove('child-open')
      });
    }); 

    // grand child menu toggle class

     document.querySelectorAll('.mobile-submenu-link-btn').forEach((elm)=>{
       
      elm.addEventListener('click', (el)=>{
        console.log('el', el)
        if( el.currentTarget.closest('.mobile-submenu-item').classList.contains("submenu-close") ){
          el.currentTarget.closest('.mobile-submenu-item').classList.remove('submenu-close');
        }
        else {
          // document.querySelectorAll('.mobile-submenu-item').forEach((e)=>{
          //   e.classList.remove('submenu-close')
          // });
          el.currentTarget.closest('.mobile-submenu-item').classList.add('submenu-close');
        } 
        
        
      });
    });

    
  
    // toggle menu event
    document.querySelector('.mm-menu-toggle').addEventListener('click', (el)=>{
      el.currentTarget.classList.toggle('open');
      document.querySelector('body').classList.toggle('menu-body-open');
      document.querySelector('.mobile-nav-drawer').classList.toggle('menu-open');
    });


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.

  

  window.cartcount = function() {
    if(typeof window.Rebuy.SmartCart !== "undefined"){
      var item_count = window.Rebuy.SmartCart.itemCount();
      var cart_title = document.querySelector('.rebuy-cart__flyout-header h2');
      var tag = document.createElement("span");
      tag.classList.add('count');
      var text = document.createTextNode(item_count);
      tag.appendChild(text);
      if(item_count > 0){
        document.querySelectorAll('.menu__item.menu__item--icons .cart_counter').forEach((c_item)=>{
          c_item.classList.remove('count-zero')
        });
        if( document.querySelectorAll('.rebuy-cart__flyout-header .count').length > 0 ){
          document.querySelector('.rebuy-cart__flyout-header .count').innerHTML = item_count;
        }else if(cart_title) {
          cart_title.appendChild(tag);
        }
      }else {
        document.querySelectorAll('.menu__item.menu__item--icons .cart_counter').forEach((c_item)=>{
          c_item.classList.add('count-zero')
        });
        if( document.querySelectorAll('.rebuy-cart__flyout-header .count').length > 0 ){
          document.querySelector('.rebuy-cart__flyout-header .count').innerHTML = '';
        }
      }
      document.querySelector('.menu__item.menu__item--icons .cart_counter').innerHTML = item_count;
      
    }
  }

  document.addEventListener('rebuy:smartcart.init', (event) => {
    //window.cartcount()
  });
  document.addEventListener('rebuy:smartcart.ready', (event) => {
		window.cartcount();
  });

  document.addEventListener('rebuy:smartcart.show', (event) => {
      window.cartcount();
      var rebuyCheckout = document.querySelector('.rebuy-cart__checkout-button');
      // how to access a free shipping tier in the Progress Bar
      
      
      // how to access the free shipping minimum
      if (Rebuy.SmartCart.progressBar != null){
        const freeShippingTier = Rebuy.SmartCart.progressBar.tiers.find(tier => tier.type === 'shipping');
        var cartPrice = window.Rebuy.Cart.cart.items_subtotal_price;
        var finalMinPrice = freeShippingTier.minimum * 100;
        var remainMinPrice = finalMinPrice - cartPrice;
        
        if (cartPrice > finalMinPrice) {
            rebuyCheckout.disabled = false;
        } else {
            rebuyCheckout.disabled = true;
        }
    
        if (cartPrice > finalMinPrice) {
            document.querySelector('.rebuy-cart__progress-bar-prompt').classList.add('success');
        } else {
            document.querySelector('.rebuy-cart__progress-bar-prompt').classList.remove('success');
        }  
      }
      var productBlocks = document.querySelectorAll(".rebuy-product-block");
  
      if (productBlocks.length > 0) {
          productBlocks.forEach(el => {
              if (el.querySelector("button.rebuy-button span").innerText.trim() !== "Add to Cart" && el.closest(".rebuy-cart__flyout-recommendations")) {
                el.closest(".rebuy-cart__flyout-recommendations").classList.add("value_button_show");
              }
          });
      }
  });

  window.protectMyPurchase = function() {
    const items = window.Rebuy.Cart.cart.items;
    const protectMyPurchaseItem = items.filter((item) => item.handle.includes("protect-my-purchase"));
    // console.log(protectMyPurchaseItem, protectMyPurchaseItem.length);
    if(document.querySelector(".rebuy-cart__checkout-button")) document.querySelector(".rebuy-cart__checkout-button").innerHTML = `<span>Proceed to checkout </span> | <span>$${((window.Rebuy.Cart.cart.total_price) / 100).toFixed(2)}</span>`;
  }

  window.changeRebuyCheckoutButton = function() {
    if(document.querySelector(".rebuy-cart__checkout-button")) document.querySelector(".rebuy-cart__checkout-button").disabled = !window.Rebuy.SmartCart.hasAcceptedTerms() && window.Rebuy.SmartCart.hasTermsEnabled();
  }

  document.addEventListener('rebuy:cart.change', function(event){ 
   //$('.cart-count-bubble span').text(window.Rebuy.SmartCart.itemCount());
    window.cartcount()
    window.protectMyPurchase();
    window.changeRebuyCheckoutButton();
  });

  document.addEventListener('rebuy:smartcart.show', (event) => {
    window.protectMyPurchase();
    window.changeRebuyCheckoutButton();
  });

  const checkDiv = setInterval(() => {
  const productBlocks = document.querySelectorAll(".rebuy-product-block");

  if (productBlocks.length > 0) {
    clearInterval(checkDiv); // Stop checking once found

    const cartContent = document.querySelector(".rebuy-cart .rebuy-cart__flyout-content");
    const flyoutItems = cartContent?.querySelector(".rebuy-cart__flyout-items");
    const flyoutRecs = cartContent?.querySelector(".rebuy-cart__flyout-recommendations");

    // Safety check
    if (!cartContent || !flyoutItems || !flyoutRecs) return;

    productBlocks.forEach((el) => {
      const buttonSpan = el.querySelector("button.rebuy-button span");
      const buttonText = buttonSpan?.innerText?.trim();

      if (buttonText && buttonText !== "Add to Cart") {
        el.closest(".rebuy-cart__flyout-recommendations")?.classList.add("value_button_show");
      }
    });

    // Add scroll behavior
    document.querySelectorAll(".rebuy-product-actions .rebuy-button").forEach((elm) => {
      elm.addEventListener("click", () => {
        const contentHeight =
          flyoutItems.offsetHeight + flyoutRecs.offsetHeight;

        setTimeout(() => {
          cartContent.scrollTo({
            top: contentHeight,
            behavior: "smooth",
          });
        }, 500);
      });
    });
  }
}, 100); 


})();

function adjustHeight(className) {
  var elements = document.querySelectorAll('.' + className);
  elements.forEach(function (element) {
    element.style.height = 'auto';
  });

  var maxHeight = -1;
  elements.forEach(function (element) {
    var height = element.offsetHeight;
    maxHeight = height > maxHeight ? height : maxHeight;
  });

  elements.forEach(function (element) {
    element.style.height = maxHeight + 'px';
  });
}

$('.collection__filters-box.cat .collection__filters-title').click(function(e) {
  $('.collection__filters-box.cat').toggleClass('active');
  $(this).next('.collection__filters-box-main').slideToggle();
});

// Function to handle the mutation changes
function handleMutation(mutationsList, observer) {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      // Check if the target element with the specified class is now available
      const containerWrapper = document.querySelector('.rc-container-wrapper.rc_container_wrapper');
      const customInjectionPoint = document.querySelector('.rc-custom-injection-point');

      if (containerWrapper && customInjectionPoint) {
        // Move the containerWrapper element to be a child of customInjectionPoint
        customInjectionPoint.appendChild(containerWrapper);

        // Disconnect the observer as the task is completed
        observer.disconnect();
      }
    }
  }
}

// Create a MutationObserver
const observer = new MutationObserver(handleMutation);

// Target element for the observer
const targetElement = document.body;

// Configure and start observing for childList changes
observer.observe(targetElement, { childList: true });


function minHeight(parentElement, childElement) {
  let productGrids = document.querySelectorAll(parentElement),
      gridPositions = [],
      positionGrids = [];
  if(productGrids.length == 0) return;
  
  productGrids.forEach(function(grid) {
    if(gridPositions.indexOf(grid.offsetTop) == -1) gridPositions.push(grid.offsetTop);
  });
  
  gridPositions.forEach(function (position) {
    let grids = Array.from(productGrids).filter(function (grid) {
      return (grid.offsetTop == position)
    });
    positionGrids.push(grids);
  });

  positionGrids.forEach((grids,index) => {
    let heights = []
    grids.forEach(function (grid) {
      let tmp = [];
      grid.querySelectorAll(childElement).forEach(function(element) {
        element.style.removeProperty('min-height');
       tmp.push(element.offsetHeight) 
      });
      heights.push(tmp);
    });
    if(heights.length > 0){
      let totalSelector = Math.max(...heights.map(ele => {
        return ele.length;
      }));
      grids.forEach(function (grid) {
        for (let index = 0; index < totalSelector; index++) {
          let elementHeights = Math.max(...heights.map(ele => {
            return ele[index];
          }));
          grid.querySelectorAll(childElement)[index].style.minHeight = `${elementHeights}px`;
        }
      });
    }
  });  
}

const checkDiv = setInterval(() => {
    const productBlocks = document.querySelectorAll(".related-product-slider.slick-initialized");
    if (productBlocks.length > 0) {
        minHeight('.related-product-slider .slick-slide', '.related-product-slider .slick-slide > div');
        clearInterval(checkDiv);
    }
}, 100); 

window.addEventListener('resize', function() {
  minHeight('.related-product-slider .slick-slide', '.related-product-slider .slick-slide > div');
  minHeight('.featured__collection--slider .slick-slide', '.featured__collection--slider .slick-slide > div');
});


const featuredElement = setInterval(() => {
  const featuredSlider = document.querySelectorAll(".featured__collection--slider.slick-initialized");
  if( featuredSlider.length > 0 ) {
      minHeight('.featured__collection--slider .slick-slide', '.featured__collection--slider .slick-slide > div');
      clearInterval(featuredSlider);
  }
}, 100); 


